import { Box, Paper, Stack, Typography } from '@mui/material';

interface BannedUserOverlayProps {
  banReason?: string | null;
}

const BannedUserOverlay = ({ banReason }: BannedUserOverlayProps) => {
  const supportEmail = process.env.NEXT_PUBLIC_SUPPORT_EMAIL || 'contact@allo-clients.com';
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
        background:
          'radial-gradient(circle at top, rgba(200,40,40,0.10), transparent 45%), linear-gradient(180deg, #faf7f2 0%, #f3ede5 100%)',
      }}
    >
      <Paper
        elevation={0}
        sx={{
          width: '100%',
          maxWidth: 620,
          p: { xs: 3, sm: 5 },
          borderRadius: 4,
          border: '1px solid',
          borderColor: 'divider',
          backgroundColor: 'rgba(255,255,255,0.9)',
          backdropFilter: 'blur(10px)',
        }}
      >
        <Stack spacing={2.5}>
          <Typography variant="overline" color="error.main" fontWeight={700}>
            Accès désactivé
          </Typography>
          <Typography variant="h5" fontWeight={700} lineHeight={1.3}>
            Votre accès AlloClients a été désactivé. Vous pouvez contacter le support à{' '}
            {supportEmail}
          </Typography>
          {banReason ? (
            <Box
              sx={{
                p: 2,
                borderRadius: 3,
                backgroundColor: 'rgba(183, 28, 28, 0.06)',
                border: '1px solid rgba(183, 28, 28, 0.12)',
              }}
            >
              <Typography variant="body2" color="text.secondary" sx={{ mb: 0.75 }}>
                Motif du blocage
              </Typography>
              <Typography variant="body1">{banReason}</Typography>
            </Box>
          ) : null}
        </Stack>
      </Paper>
    </Box>
  );
};

export default BannedUserOverlay;
